module.exports = __webpack_public_path__ + "static/media/fitnessApp-min.3c439744.png";